import axios from "axios";
import { ILogin, Login } from "../records/Login";
import RestApi from "../../../utils/RestApi";
import CookieUtils from "../../../utils/CookieUtils";
import JwtUtils from "../../../utils/JwtUtils";

class LoginApi
{
    public async getToken(username: string, password: string): Promise<ILogin>
    {
        let url = await RestApi.getUrl(`/v1/user/${username}/token`);
        let cfg = {
            auth: {
                username: username,
                password: password
            }
        };

        const result = await axios.get(url, cfg);

        if (result.status !== 200)
        {
            throw new Error("Login failed");
        }

        return result.data as ILogin;
    }

    public async revokeToken(username: string, password: string): Promise<any>
    {
        let url = await RestApi.getUrl(`/v1/user/${username}/token`);
        let cfg = {
            auth: {
                username: username,
                password: password
            }
        };

        const result = await axios.delete(url, cfg);

        if (result.status !== 200)
        {
            throw new Error("Revoke token failed");
        }

        return;
    }

    public async changePassword(newPassword: string): Promise<any>
    {
        const cookie = CookieUtils.getCookie("GameScorekeeper");
        if (!cookie) {
            return;
        }

        const jwtPayload = JwtUtils.getJWTPayload(cookie);
        const username = jwtPayload.sub;

        let url = await RestApi.getUrl(`/v1/user/${username}`);
        let body = {
            newPassword: newPassword
        };

        const result = await axios.put(url, body);

        if (result.status !== 200)
        {
            throw new Error("Revoke token failed");
        }

        return;
    }
}

export default new LoginApi();
